import {
	type ApolloClientInterface,
	createAtlassianGatewayClient,
	createTeamCentralClient,
	createWorklensClient,
	createApolloClient as newApolloClient,
} from '@atlassian/ptc-graphql-client';
import { DEV, getConfig } from '@atlassian/teams-common/context-config';

import { withDefaultExponentialBackoff } from '../utils/http';

const customFetch = withDefaultExponentialBackoff(fetch);

/*************************************************/
// a common Apollo Client
let cachedApolloClient: ReturnType<typeof createApolloClient> | undefined;

export const getApolloClient = (customConfig?: Partial<ApolloClientInterface>) => {
	if (cachedApolloClient) {
		return cachedApolloClient;
	}

	const apolloClient = createApolloClient(customConfig);
	// don't cache apolloClient when cloudId is empty string
	if (customConfig?.getCloudId && customConfig?.getCloudId()) {
		cachedApolloClient = apolloClient;
	}

	return apolloClient;
};

export const createApolloClient = (customConfig?: Partial<ApolloClientInterface>) =>
	newApolloClient({
		connectToDevTools: !!DEV,
		url: {
			stargateRoot: getConfig().stargateRoot,
			collaborationGraph: getConfig().collaborationGraph,
		},
		customFetch,
		...customConfig,
	});

/*************************************************/
// Worklens client
let cachedWorklensClient: ReturnType<typeof createWorklensClient> | undefined;
export const getWorklensClient = () => {
	if (cachedWorklensClient) {
		return cachedWorklensClient;
	}

	cachedWorklensClient = createWorklensClient({
		url: {
			stargateRoot: getConfig().stargateRoot,
		},
		customFetch,
	});

	return cachedWorklensClient;
};

/*************************************************/
// GraphQL Gateway client
let cachedGatewayClient: ReturnType<typeof createAtlassianGatewayClient> | undefined;
export const getGatewayClient = () => {
	if (cachedGatewayClient) {
		return cachedGatewayClient;
	}

	cachedGatewayClient = createAtlassianGatewayClient({
		url: {
			stargateRoot: getConfig().stargateRoot,
		},
		customFetch,
	});

	return cachedGatewayClient;
};

/*************************************************/
// GraphQL Team Central client
let cachedTeamCentralClient: ReturnType<typeof createTeamCentralClient> | undefined;
export const getTeamCentralClient = () => {
	if (cachedTeamCentralClient) {
		return cachedTeamCentralClient;
	}

	cachedTeamCentralClient = createTeamCentralClient({
		url: {
			stargateRoot: getConfig().stargateRoot,
		},
		customFetch,
	});

	return cachedTeamCentralClient;
};
